import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { AuthenticationService } from "../../_services/authentication.service";
import { AlertService } from "../../_services/alert.service";

/**
 * The login as it is on `main`, routed to while the `twoFactorLogin` flag is off
 *
 * TODO: Review of the Android Enter-key fix (PR 71) says the root cause is a poor use of an HTML <form>, which,
 * in the reviewer's opinion, should not have been here in the first place. The proper fix is to remove the <form>
 * elements where they are not needed.
 * A comprehensive fix is needed later: decide whether the <form> should be removed or not, and how to handle it.
 * Things to weigh: a <form> brings implicit submission on Enter (the cause of the bug) and a hidden "default button",
 * but it is also what password managers, browser autofill and accessibility rely on in a login screen, and without it
 * Enter has to be handled by hand (the old keyCode 13 handler, which Android keyboards bypass with keyCode 229).
 * For now the fix is only `type="button"` on the "new user" button and no key handler, so Enter submits through ngSubmit.
 */
@Component({
  moduleId: module.id,
  templateUrl: "legacy-login.component.html",
  styleUrls: ["legacy-login.component.scss"],
})
export class LegacyLoginComponent implements OnInit {
  model: any = {};
  loading = false;
  returnUrl: string;
  isPasswordVisible = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private sessionManager: SessionManagerService
  ) { }

  ngOnInit() {
    localStorage.removeItem("allowShowPopup");
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
  }

  forgotPassword() {
    this.router.navigate(["/forgotpassword"]);
  }

  toggleVisibility(event: MouseEvent) {
    event.preventDefault();
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  login() {
    this.loading = true;

    this.authenticationService
      .legacyLogin(this.model.username, this.model.password)
      .subscribe(
        (data) => {
          this.sessionManager.recordUserLoginTime();
          this.router.navigate([this.returnUrl]);
        },
        (error) => {
          if (error && error.status !== 200) {
            if (error.status === 504 || error.status === 502) {
              this.alertService.error("שגיאה בהתחברות לשרת");
            } else {
              try {
                const body = error.json && error.json();
                this.alertService.error(
                  (body && body.statusText) || error.statusText
                );
              } catch (err) {
                this.alertService.error(err);
              }
            }
            this.loading = false;
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/login/legacy-login/legacy-login.component.ts